// This example shows you how to set up React Stripe.js and use Elements.
// Learn how to accept a payment using the official Stripe docs.
// https://www.stripe.com/docs/payments/integration-builder

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

import "../css/global.css";

import check from "../assets/check.png";
import error from "../assets/error.png";

const PaymentModal = ({ isSuccess }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  let history = useHistory();

  const onButtonClick = () => {
    setIsOpenModal(false);
    history.replace("/stripe/");
  };

  useEffect(() => {
    if (isSuccess) {
      setIsOpenModal(true);
    }
  }, [isSuccess]);

  return (
    isOpenModal && (
      <div id="myModal" className="modal">
        <div className="modal-content">
          <span className="close" onClick={onButtonClick}>
            &times;
          </span>
          {isSuccess === "true" ? (
            <>
              <img className="checkIcon" src={check} alt="success" />
              <span className="modalText">Great!</span>
              <span className="mediumModalText">
                Λεπτομερείς πληροφορίες έχουν σταλεί στο email σας!
              </span>
              <span className="smallModalText">
                Εάν έχετε οποιεσδήποτε ερωτήσεις, παρακαλούμε επικοινωνήστε μαζί
                μας στο <span className="greenText">support@lavoria.com</span>
              </span>
              <button className="greenButton" onClick={onButtonClick}>
                Εντάξει
              </button>
            </>
          ) : (
            <>
              <img className="checkIcon" src={error} alt="error" />
              <span className="modalText">Κάτι πήγε στραβά</span>
              <span className="mediumModalText">
                Δοκιμάστε ξανά ή στείλτε μας email support@lavoria.com
              </span>
              <button className="greyButton" onClick={onButtonClick}>
                Προσπάθησε ξανά.
              </button>
            </>
          )}
        </div>
      </div>
    )
  );
};

export default PaymentModal;
